import { Component, OnInit, ViewChild } from '@angular/core';
import { CondiaparpreService } from "../conservicios/condiaparpre.service";
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { Diaparpreenc } from "../coninterfaces/conencdiaparpre";
import { Diaparpredet } from "../coninterfaces/condetdiaparpre";
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { isNullOrUndefined, isNull } from 'util';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-condiaparpre',
  templateUrl: './condiaparpre.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class CondiaparpreComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  btnNuevo: boolean;
  btnGuardar: boolean;
  btnBorrar: boolean;
  btnRegresar: boolean;
  indicador: any;
  index
  permisodiaParpre: SegMaePermiso;
  detdiaparpretselected: Diaparpredet
  estadoanio: string

  //agrgrid
  rowSelection = 'multiple';
  public frameworkComponents;
  defaultColDefDiaParpre;
  rowStyle;
  spin = false
  btnNuevoGrid: boolean;
  btnBorrarGrid: boolean;
  btnCancelarGrid: boolean;
  arraynummeses: any = []
  arraymesesnum: any = []
  //busqueda
  opcion: string;
  types: SelectItem[];
  arregloCons: any[];
  displayDialogBusquedaFast: boolean;
  busquedacampos: string[];
  tabla: string;
  where: string;

  columnDefsDiaParpre = [
    {
      headerName: 'Número', field: 'DETPARPRE_NUMERO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return true;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 30,
          opcionbuscar: true
        }
      }

    },
    {
      headerName: 'Nombre', field: 'DETPARPRE_NOMBRE', cellEditor: 'cellPrueba', width: 180, editable: (params) => {
        return false;
      },
    },
    {
      headerName: 'Mes', field: 'DETDIAPAR_MES', cellEditor: 'agSelectCellEditor', width: 100, editable: (params) => {
        return true;
      },
      cellEditorParams: {
        values: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
      }
    },

    { // 2
      headerName: 'Concepto', field: 'DETDIAPAR_CONCEPTO', cellEditor: 'cellPrueba', width: 200,

      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 250
        }
      }
    },
    {
      headerName: 'Importe', field: 'DETDIAPAR_IMPORTE', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          numposneg:true

        }
      }
    }

  ]
  constructor(
    private init: NuevoComponentService, private messageService: MessageService, private confirmationService: ConfirmationService,
    public condiaparpreService: CondiaparpreService,
    private permisosService: PermisosService, private auditoriagral: AuditoriagralService,
    private busquedaSer: InvbusquedaService, private utilitariosService: UtilitariosService, private datePipe: DatePipe,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefDiaParpre = {
      editable: true,
      width: 130,
      objeto: 'diaparpre'
    };

  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;

    this.btnNuevoGrid = false;
    this.btnCancelarGrid = false;
    this.btnBorrarGrid = false;

    this.index = 0;
    this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador] = {};
    this.condiaparpreService.detdiaparprearray = [];
    this.detdiaparpretselected = {}
    this.estadoanio = '';
    this.arraynummeses = { '01': 'Enero' ,  '02': 'Febrero' ,  '03': 'Marzo' ,  '04': 'Abril' ,  '05': 'Mayo' ,
     '06': 'Junio' ,  '07': 'Julio' ,  '08': 'Agosto' ,  '09': 'Septiembre' ,  '10': 'Octubre' ,  '11': 'Noviembre' ,  '12': 'Diciembre' }
    
    this.arraymesesnum={  'Enero':'01' ,   'Febrero' :'02',  'Marzo': '03' ,   'Abril':'04' ,   'Mayo':'05' ,
      'Junio':'06' ,   'Julio':'07' ,  'Agosto':'08' ,   'Septiembre':'09' ,   'Octubre':'10' ,   'Noviembre':'11' ,   'Diciembre':'12' }
    // const opciones=['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
    // this.columnDefsDiaParpre[0].cellEditorParams = {
    //   values: opciones
    // }
    // this.aggrid.refreshColumnDefsIndice(this.indicador, this.defaultColDefDiaParpre.objeto, this.columnDefsDiaParpre);
    await this.getPermisos();
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisodiaParpre = data[0];
        } else {
          this.permisodiaParpre = null;
        }
      } else {
        this.permisodiaParpre = null;
      }
    } catch (e) {
      this.permisodiaParpre = null;
      this.messageService.add({
        key: 'diaparpre',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  async manejarSenales(evento) {
    if (evento !== 'Nuevo' && evento !== 'Cancelar'
      && evento !== 'Primero' && evento !== 'Anterior' && evento !== 'Siguiente' && evento !== 'Ultimo'
      && evento !== 'Buscar' && evento !== 'Imprimir' && evento !== 'AsientoVer' && evento !== 'Salir'
      && evento !== 'facturasAbonadas') {
      // Verifica el periodo contable
      const dia = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA.getDate();
      const mes = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA.getMonth();
      const anio = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA.getFullYear();


      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.messageService.add({
          key: 'diaparpre',
          severity: 'info',
          summary: 'Información',
          detail: 'Error, fecha debe de estar dentro del período contable'
        });
        return;
      }
    }

    if (evento === 'Nuevo') {
      if (this.permisodiaParpre.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisodiaParpre.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada.'
          });
        }
      }
    }
    if (evento === 'Guardar') {

      if (this.permisodiaParpre.PERTODO === 1) {
        this.spin = true;
        this.validaguardar();
      } else {
        if (this.permisodiaParpre.PERACTUALIZACION === 1) {
          this.spin = true;
          this.validaguardar();
        } else {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Buscar') {
      if (this.permisodiaParpre.PERTODO === 1) {
        this.busqueda()
      } else {
        if (this.permisodiaParpre.PERSELECCION === 1) {
          this.busqueda()
        } else {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de consulta, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Borrar') {

      if (this.index === 0) {
        if (this.permisodiaParpre.PERTODO === 1) {
          this.confirmarborrar();
        } else {
          if (this.permisodiaParpre.PERELIMACION === 1) {
            this.confirmarborrar();
          } else {
            this.messageService.add({
              key: 'diaparpre',
              severity: 'error',
              summary: 'Información',
              detail: 'El usuario no tiene permisos de eliminación, acción denegada.'
            });
          }
        }
      }
    }
    if (evento === 'Cancelar') {
      this.cancelar()
    }
    if (evento === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  busqueda() {
    this.opcion = 'BUSQUEDA';
    this.types = [
      { label: 'Número', value: 'ENCDIAPAR_NUMERO' },
      { label: 'Año', value: 'ENCPARPRE_ANIO' },
      { label: 'Concepto', value: 'ENCDIAPAR_CONCEPTO' },
    ];
    this.busquedacampos = ['', '', ''];
    this.tabla = 'CON_ENCDIAPARPRE';
    this.where = ''
    this.busquedaSer.busquedaEndiapar().subscribe((res: any[]) => {
      if (res !== null && res !== undefined) {
        this.arregloCons = res;
        this.displayDialogBusquedaFast = true;
      } else {
        this.messageService.add({
          key: 'diaparpre',
          severity: 'error',
          summary: 'INFORMACIÓN',
          detail: 'Aún no hay ninguna partida'
        });
        this.spin = false;
        return;
      }
    });
  }
  manejarSeleccion(opcion) {
    this.obtenerdatos(opcion.ENCDIAPAR_NUMERO)
    this.displayDialogBusquedaFast = false
  }
  confirmarborrar() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmdiaparpre',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.eliminarregistro();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async eliminarregistro() {
    try {
      await this.condiaparpreService.eliminarregistro(this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_NUMERO);
      this.messageService.add({
        key: 'diaparpre',
        severity: 'success',
        summary: 'Eliminar Presupuesto',
        detail: 'Se eliminó con éxito el registro'
      });
      this.auditoriagral.registrarAuditoria('CON_ENCDIAPARPRE', this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_NUMERO, 'E',
        '', '01', '', '', '', '').subscribe(() => { });
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
      this.spin = false
      this.index = 0;
      this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador] = {};
      this.condiaparpreService.detdiaparprearray = [];

    } catch (error) {
      this.messageService.add({
        key: 'diaparpre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al eliminar el registro'
      });
      return;
    }
  }
  async validaguardar() {
    try {
      const anios = Array.from(new Set(this.condiaparpreService.detdiaparprearray.map(item => String(item.ENCPARPRE_ANIO))))
      let anio = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCPARPRE_ANIO
      for (const iteranios of anios) {
        if (iteranios !== anio) {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El año del encabezado debe ser igual a los años en el detalle'
          });
          
          return;
        }
      }
      if (isNullOrUndefined(this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA) ||
        this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA === '') {
        this.messageService.add({
          key: 'diaparpre',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo fecha no puede estar vacío'
        });
        return;
      }
      if (isNullOrUndefined(this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCPARPRE_ANIO) ||
        this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCPARPRE_ANIO === '') {
        this.messageService.add({
          key: 'diaparpre',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo año no puede estar vacío'
        });
        return;
      }
      if (isNullOrUndefined(this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_CONCEPTO) ||
        this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_CONCEPTO === '') {
        this.messageService.add({
          key: 'diaparpre',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo concepto no puede estar vacío'
        });
        return;
      }
      if (this.condiaparpreService.detdiaparprearray.length === 0) {
        this.messageService.add({
          key: 'diaparpre',
          severity: 'error',
          summary: 'Información',
          detail: 'El detalle no puede estar vacío'
        });
        return;
      }
      for (const item of this.condiaparpreService.detdiaparprearray) {
        const data = await this.condiaparpreService.validadetparprenum(item.DETPARPRE_NUMERO, item.ENCPARPRE_ANIO);
        let numero = 0;
        if (isNullOrUndefined(data) == false) {
          for (const iterator of data) {
            numero = iterator.NUMERO

          }
        }
        if (numero === 0) {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El número ' + item.DETPARPRE_NUMERO + ' no existe en la partida presupuestaria o la partida no está autorizada'
          });
          return;
        }
        if (isNullOrUndefined(item.DETPARPRE_NUMERO) || item.DETPARPRE_NUMERO === '') {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El campo número no puede estar vacío'
          });
          return;
        }
        if (isNullOrUndefined(item.DETPARPRE_NOMBRE) || item.DETPARPRE_NOMBRE === '') {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El campo nombre no puede estar vacío'
          });
          return;
        }
        if (isNullOrUndefined(item.DETDIAPAR_MES) || item.DETDIAPAR_MES === '') {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El campo mes no puede estar vacío'
          });
          return;
        }
        if (isNullOrUndefined(item.DETDIAPAR_CONCEPTO) || item.DETDIAPAR_CONCEPTO === '') {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El campo concepto no puede estar vacío'
          });
          return;
        }
        if (isNullOrUndefined(item.DETDIAPAR_IMPORTE) || item.DETDIAPAR_IMPORTE === '') {
          this.messageService.add({
            key: 'diaparpre',
            severity: 'error',
            summary: 'Información',
            detail: 'El campo importe no puede estar vacío'
          });
          return;
        }

      }
      await this.guardar();
    } catch (error) {
      this.messageService.add({
        key: 'diaparpre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar la información'
      });
      return;
    }
  }
  async guardar() {
    try {
      let numero = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_NUMERO
      if (numero === '' || isNullOrUndefined(numero)) {
        if (this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA.toString().includes('-')) {
          this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA = this.datePipe.transform(this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA,'dd/MM/yyyy')
        }
        const dato = await this.condiaparpreService.insertarencdiapar(this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador])
        if (isNullOrUndefined(dato) === false) {
          for (const iterator of dato) {
            let numero = iterator.ENCDIAPAR_NUMERO
            this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_NUMERO=numero
            this.auditoriagral.registrarAuditoria('CON_ENCDIAPARPRE',
              numero + '/año:' + this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCPARPRE_ANIO, 'I', '', '01', '', '', '', '').subscribe();
            for (const iterator of this.condiaparpreService.detdiaparprearray) {
              iterator.ENCDIAPAR_NUMERO=numero
              iterator.DETDIAPAR_MES=this.arraymesesnum[iterator.DETDIAPAR_MES]
              if (iterator.DETDIAPAR_LINEA === 0) {
                await this.condiaparpreService.insertardetdiapar(iterator);
                this.auditoriagral.registrarAuditoria('CON_DETDIAPARPRE',
                  numero + '/' + iterator.DETPARPRE_NUMERO + '/' + iterator.DETDIAPAR_MES + '/' + iterator.DETDIAPAR_IMPORTE, 'I', '', '01', '', '', '', '').subscribe();
              } else {
                await this.condiaparpreService.insertardetdiapar(iterator);
                this.auditoriagral.registrarAuditoria('CON_DETDIAPARPRE',
                  numero + '/' + iterator.DETPARPRE_NUMERO + '/' + iterator.DETDIAPAR_MES + '/' + iterator.DETDIAPAR_IMPORTE, 'A', '', '01', '', '', '', '').subscribe();
              }
            }
            this.messageService.add({
              key: 'diaparpre',
              severity: 'success',
              summary: 'Insertar diario',
              detail: 'Se ingresó con éxito el registro'
            });
            await this.cancelar()
          }
        }
      } else {
        if (this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA.toString().includes('-')) {
          this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA = this.datePipe.transform(this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_FECHA,'dd/MM/yyyy')
        }
        const dato = await this.condiaparpreService.insertarencdiapar(this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador])
        if (isNullOrUndefined(dato) === false) {
          for (const iterator of dato) {
            let numero = iterator.ENCDIAPAR_NUMERO
            this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_NUMERO=numero
            this.auditoriagral.registrarAuditoria('CON_ENCDIAPARPRE',
              numero + '/año:' + this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCPARPRE_ANIO, 'A', '', '01', '', '', '', '').subscribe();
            for (const iterator of this.condiaparpreService.detdiaparprearray) {
              iterator.ENCDIAPAR_NUMERO=numero
              iterator.DETDIAPAR_MES=this.arraymesesnum[iterator.DETDIAPAR_MES]
              if (iterator.DETDIAPAR_LINEA === 0) {
                await this.condiaparpreService.insertardetdiapar(iterator);
                this.auditoriagral.registrarAuditoria('CON_DETDIAPARPRE',
                  numero + '/' + iterator.DETPARPRE_NUMERO + '/' + iterator.DETDIAPAR_MES + '/' + iterator.DETDIAPAR_IMPORTE, 'I', '', '01', '', '', '', '').subscribe();
              } else {
                await this.condiaparpreService.insertardetdiapar(iterator);
                this.auditoriagral.registrarAuditoria('CON_DETDIAPARPRE',
                  numero + '/' + iterator.DETPARPRE_NUMERO + '/' + iterator.DETDIAPAR_MES + '/' + iterator.DETDIAPAR_IMPORTE, 'A', '', '01', '', '', '', '').subscribe();
              }
            }
            this.messageService.add({
              key: 'diaparpre',
              severity: 'success',
              summary: 'Actualizar diario',
              detail: 'Se actualizó con éxito el registro'
            });
            await this.cancelar()
          }
        }
        
      }
    } catch (error) {
      this.messageService.add({
        key: 'diaparpre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al guardar el diario'
      });
      return;
    }
  }
  cancelar() {
    let numero = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_NUMERO
    if (numero === '' || isNullOrUndefined(numero)) {
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
      this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador] = {};
      this.condiaparpreService.detdiaparprearray = [];
      this.detdiaparpretselected = {}
    } else {
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
      this.obtenerdatos(numero);
    }
  }
  nuevo() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador] = {};
    this.condiaparpreService.detdiaparprearray = [];
    this.detdiaparpretselected = {}
    const dato: Diaparpreenc = {
      ENCDIAPAR_NUMERO: '',
      ENCPARPRE_ANIO: '',
      ENCDIAPAR_CONCEPTO: '',
      ENCDIAPAR_FECHA: new Date(),
      USUIDENTIFICACION: '',
      COM_CODIGO: '01',
    }
    this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador] = dato

    document.getElementById('ENCPARPRE_ANIO').focus();
  }

  async obtenerdatos(numero) {
    try {
      const dato = await this.condiaparpreService.getencdiapar(numero)
      if (isNullOrUndefined(dato) === false) {
        for (const iterator of dato) {
          iterator.ENCDIAPAR_FECHA=new Date(iterator.ENCDIAPAR_FECHA)
          this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador] = iterator;
          
          const detalle = await this.condiaparpreService.getdetdiapar(numero);
          for (const iterator of detalle) {
            iterator.DETDIAPAR_IMPORTE = Number(iterator.DETDIAPAR_IMPORTE).toFixed(2)
            iterator.DETDIAPAR_MES=this.arraynummeses[iterator.DETDIAPAR_MES]
          }
          this.condiaparpreService.detdiaparprearray = detalle
        }
      }
    } catch (error) {
      this.messageService.add({
        key: 'diaparpre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar la información'
      });
      return;
    }
  }
  cambio(evento) {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
  }
  setFocus(event) {
    switch (event.target.id) {
      case 'ENCPARPRE_ANIO': {
        document.getElementById('ENCDIAPAR_CONCEPTO').focus();
        break;
      }
      default: {
        break;
      }
    }
  }

  selectedDiaParpre(params) {
    let anio = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCPARPRE_ANIO
    if (params === 'nuevo') {
      if (isNullOrUndefined(anio) || anio === '') {
        this.messageService.add({
          key: 'diaparpre',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un año'
        });
        return
      }
      this.nuevodetalle();
      return;
    }
    if (params === 'eliminar') {
      if (isNullOrUndefined(this.detdiaparpretselected)) {
        this.messageService.add({
          key: 'diaparpre',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un registro del detalle'
        });
        return
      }
      this.confirmaeliminadet();
    }
    if (params.object !== undefined) {
      this.detdiaparpretselected = params.object;
    }
  }
  confirmaeliminadet() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmdiaparpre',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.eliminarregistrodet();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async eliminarregistrodet() {
    try {
      if (this.detdiaparpretselected.DETDIAPAR_LINEA === 0) {     
        this.condiaparpreService.detdiaparprearray = this.condiaparpreService.detdiaparprearray.filter((val, j) => j !==
          this.condiaparpreService.detdiaparprearray.indexOf(this.detdiaparpretselected));
          this.aggrid.refreshaggrid(this.condiaparpreService.detdiaparprearray, this.defaultColDefDiaParpre.objeto);
          this.messageService.add({
            key: 'diaparpre',
            severity: 'success',
            summary: 'Insertar diario',
            detail: 'Se eliminó con éxito el registro'
          });
          
      } else {
        let numero = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_NUMERO
        await this.condiaparpreService.eliminarregistrodet(this.detdiaparpretselected);
        this.condiaparpreService.detdiaparprearray = this.condiaparpreService.detdiaparprearray.filter((val, j) => j !==
        this.condiaparpreService.detdiaparprearray.indexOf(this.detdiaparpretselected));

        this.auditoriagral.registrarAuditoria('CON_DETDIAPARPRE',
          numero + '/' + this.detdiaparpretselected.DETPARPRE_NUMERO, 'E', '', '01', '', '', '', '').subscribe();
        this.aggrid.refreshaggrid(this.condiaparpreService.detdiaparprearray, this.defaultColDefDiaParpre.objeto);
        this.messageService.add({
          key: 'diaparpre',
          severity: 'success',
          summary: 'Insertar diario',
          detail: 'Se eliminó con éxito el registro'
        });
      }
    } catch (error) {
      this.messageService.add({
        key: 'diaparpre',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un problema al elimnar la línea'
      });
      return
    }
  }
  nuevodetalle() {
    try {
      let anio = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCPARPRE_ANIO
      let numero = this.condiaparpreService.encabezadoDiaParpreSelectarray[this.indicador].ENCDIAPAR_NUMERO
      let detdiaparpre: Diaparpredet = {
        ENCPARPRE_ANIO: anio,
        COM_CODIGO: '01',
        DETDIAPAR_CONCEPTO: '',
        DETDIAPAR_IMPORTE: Number(0).toFixed(2),
        DETDIAPAR_LINEA: 0,
        DETPARPRE_NUMERO: '',
        ENCDIAPAR_NUMERO: numero,
      }
      const indi = this.condiaparpreService.detdiaparprearray.indexOf(this.detdiaparpretselected);
      if (indi === -1) {
        this.condiaparpreService.detdiaparprearray.push(detdiaparpre);
        this.detdiaparpretselected = detdiaparpre;
        this.aggrid.refreshaggrid(this.condiaparpreService.detdiaparprearray, this.defaultColDefDiaParpre.objeto);

        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefDiaParpre.objeto].setFocusedCell(
          this.condiaparpreService.detdiaparprearray.length - 1, 'DETPARPRE_NUMERO');
      } else {
        this.condiaparpreService.detdiaparprearray.splice(indi + 1, 0, detdiaparpre);
        this.detdiaparpretselected = detdiaparpre;
        this.aggrid.refreshaggrid(this.condiaparpreService.detdiaparprearray, this.defaultColDefDiaParpre.objeto);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefDiaParpre.objeto].setFocusedCell(
          this.condiaparpreService.detdiaparprearray.length - 1, 'DETPARPRE_NUMERO');
      }
    } catch (error) {

    }
  }
  cambioTab() {

  }
}
